import { inject, injectable } from 'inversify';
import INJECTION_TOKENS from '../../generic/ioc/injection-tokens.ts';
import type { LocationPort } from '../port/location.port.ts';
import { City } from '../model/location.ts';

@injectable()
export class GetCitiesUseCase {
  constructor(
    @inject(INJECTION_TOKENS.LOCATION_REPOSITORY)
    private readonly locationRepository: LocationPort
  ) {}

  async execute(cityToSearch: string): Promise<City[]> {
    return this.locationRepository.getCities(cityToSearch);
  }
}
